// This is generated.  Alter it in blockGroups/formElements/types/ReadOnlyText.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(hNode) {
    const { id, title, propertyName } = hNode;
    //This block tells us nothing about namespaces/relations
    const subDataDictionary = {};

    // Build the string schema as optional because read-only display fields should not be required in write payloads.
    const stringOptions = {
      title: title,
      format: 'generic',
      'x-id': id,
      'x-dataType': 'string',
      'x-propertyName': propertyName,
      'x-required': false,
      'x-optional': true,
      readOnly: true,
    };

    const readOnlyTextSchema = Type.Optional(Type.String(stringOptions));

    // The partial type definition is a plain object with the property schema
    const partialTypeDefinition = {
      [propertyName]: readOnlyTextSchema,
    };

    return [subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'formElements',
  'ReadOnlyText',
  module.exports,
);
